module.exports = __webpack_public_path__ + "65abb414bf7b7fe854ee8d2fedf7a93b.svg";